import {compact} from '@benchling/js-utils';
import React from 'react';

import {getAccessibleOrInaccessibleId} from 'graphql-client/InaccessibleInfo';
import AnalysisChip from 'ui-library/chips/AnalysisChip';
import {ChipSize} from 'ui-library/chips/Chip';
import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';
import ProcessChip from 'ui-library/chips/ProcessChip';

import {GetChipPopoverContentsArgs} from '../ChipUtilConstants';
import {getNameField, getStatusField} from '../getDefaultProcessTaskChipPopoverContent';

export default function getPipelineTaskChipPopoverContent({
  processTask,
  icon,
}: GetChipPopoverContentsArgs): Array<ChipPopoverInfoField> {
  return compact([
    getNameField(processTask, icon),
    getStatusField(processTask),
    processTask.analysis != null
      ? {
          label: 'Analysis',
          value: (
            <AnalysisChip id={getAccessibleOrInaccessibleId(processTask.analysis)} size={ChipSize.MINI} />
          ),
        }
      : null,
    {
      label: 'Task group',
      value: <ProcessChip id={processTask.process.id} size={ChipSize.MINI} />,
    },
  ]);
}
